/**
 * Debounce utility for reducing function call frequency
 * Useful for API calls triggered by user input (typing, scrolling, etc.)
 */

export const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

/**
 * Throttle utility for limiting function call frequency
 * Useful for window resize, scroll events, etc.
 */
export const throttle = (func, delay) => {
    let lastCall = 0;
    return (...args) => {
        const now = Date.now();
        if (now - lastCall >= delay) {
            lastCall = now;
            func(...args);
        }
    };
};
